import { render } from "./IntegratedWrap.vue?vue&type=template&id=6fce4dd0&scoped=true"
import script from "./IntegratedWrap.vue?vue&type=script&lang=js"
export * from "./IntegratedWrap.vue?vue&type=script&lang=js"

import "./IntegratedWrap.vue?vue&type=style&index=0&id=6fce4dd0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fce4dd0"]])

export default __exports__